export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el programa');









  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-programa.js